import React, { Fragment, forwardRef, useEffect, useRef, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import constants from '../../../constants'
import { Button } from 'reactstrap'
// import sortIcon from '../../../assests/images/sorting-icon.svg'
import moment from 'moment'
import SkeletonTable from '../../../components/SkeletonTable'
// import viewIcon from '../../../assests/images/view-icon.svg'
import { useQueryState } from 'use-location-state'
import PropTypes from 'prop-types'
import qs from 'query-string'
import { getUserContestList, clearUserContestExportData } from '../../../actions/userContest'

const UserContestContent = forwardRef((props, excelRef) => {
  const authState = useSelector(state => state.auth)
  const { adminData, token } = authState
  const { userContestList } = useSelector(state => state.userContest)
  const permission = (adminData.aPermissions && adminData.aPermissions.length && adminData.aPermissions.find(e => e.eKey === 'USERCONTEST').eType) ? adminData.aPermissions.find(e => e.eKey === 'USERCONTEST').eType : adminData.eType === 'SUPER' ? constants.WRITE_PERMISSION : constants.NO_PERMISSION

  // const [modalMessage, setModalMessage] = useState(false)
  const [offset, setOffset] = useQueryState('pageSize', 10)
  const [list, setList] = useState([])
  const [activePageNo, setPageNo] = useQueryState('page', 1)
  const [startDate, setStartDate] = useQueryState('startDate', '')
  const [endDate, setEndDate] = useQueryState('endDate', '')
  const [order, setOrder] = useQueryState('order', 'desc')
  const [search, setSearch] = useQueryState('search', '')
  const [cType, setCType] = useQueryState('cType', '')
  const [cStatus, setCStatus] = useQueryState('cStatus', '')
  const [sort] = useQueryState('sortBy', 'dStartTime')
  const [loading, setLoading] = useState(false)
  // const [message, setMessage] = useState('')
  // const [status, setStatus] = useState(false)
  // const [selectionRange, setselectionRange] = useState({
  //   startDate: null,
  //   endDate: new Date(),
  //   key: 'selection'
  // })
  const searchProp = props.search
  const startDateProp = props.startDate
  const endDateProp = props.endDate
  const openPickerProp = props.openPicker
  const contestStatusProp = props.contestFilter.status
  const contestTypeProp = props.contestFilter.type
  const previousProps = useRef({
    userContestList,
    searchProp,
    startDateProp,
    endDateProp,
    openPickerProp,
    contestStatusProp,
    contestTypeProp
    // excelExportData
  }).current

  // const contestStatusProp = props.contestFilter.status

  const dispatch = useDispatch()
  useEffect(() => {
    if (props.location.state) {
      // setModalMessage(true)
      // setStatus(true)
      // setMessage(props?.location?.state?.message)
      props.history.replace()
    }
    const page = 1
    const limit = offset
    const orderVal = 'desc'
    const obj = qs.parse(props.location.search)
    if (obj) {
      setPageNo(obj.page || page)
      setOffset(obj.pageSize || limit)
      setOrder(obj.order || orderVal)
      // if (obj.startDate && obj.endDate) {
      //   setselectionRange({
      //     startDate: new Date(obj.startDate),
      //     endDate: new Date(obj.endDate),
      //     key: 'selection'
      //   })
      //   props.handleDateRangePicker(false, obj.startDate, obj.endDate)
      // }
    }
    const start = ((obj.page || page) - 1) * (obj.pageSize || limit)
    dispatch(getUserContestList(start, limit, sort, order, search, startDate, endDate, { cStatus, cType }, false ,"U", token))
    setLoading(true)

    return () => {
      dispatch(clearUserContestExportData())
    }
  }, [])

  // const processExcelExportData = data => data.map((uc) => {
  //   let dStartTime = moment(data.dStartTime).local().format('lll')
  //   dStartTime = dStartTime === 'Invalid date' ? ' - ' : dStartTime
  //   const eStatus = uc.eStatus === 'P' ? 'Pending' : uc.eStatus === 'U' ? 'Upcoming' : uc.eStatus === 'L' ? 'Live' : uc.eStatus === 'CMP' ? 'Completed' : 'Cancel'
  //   const dPrizeDistribution = uc.eStatus == 'CMP' ? (data.dPrizeDistribution ? 'Completed' : 'Pending') : '-'
  //   return {
  //     ...uc,
  //     eType: uc.eType === 'TB' ? 'Time Based' : 'Ready To Play',
  //     dStartTime,
  //     eStatus,
  //     dPrizeDistribution
  //   }
  // })

  // useEffect(() => {
  //   if (previousProps.excelExportData !== excelExportData) {
  //     if (excelExportData && excelExportData.results && excelExportData.results.length) {
  //       exporter.current.props = { ...exporter.current.props, data: processExcelExportData(excelExportData.results), fileName: 'UserContests.xlsx' }
  //       exporter.current.save()
  //     }
  //   }
  //   return () => {
  //     previousProps.excelExportData = excelExportData
  //   }
  // }, [excelExportData])

  useEffect(() => {
    if (previousProps.userContestList !== userContestList) {
      if (userContestList && userContestList.results) {
        setList(userContestList.results)
      } else if (userContestList && (!userContestList.results || !userContestList.results.length)) {
        setList([])
      }
      setLoading(false)
    }
    return () => {
      previousProps.userContestList = userContestList
    }
  }, [userContestList])

  useEffect(() => {
    if (previousProps.contestStatusProp !== contestStatusProp || previousProps.contestTypeProp !== contestTypeProp) {
      const start = 0
      const limit = offset
      dispatch(getUserContestList(start, limit, sort, order, search, startDate, endDate, { cStatus: contestStatusProp, cType: contestTypeProp }, false, "U",token))
      setCStatus(contestStatusProp)
      setCType(contestTypeProp)
      setPageNo(1)
      setLoading(true)
    }
    return () => {
      previousProps.contestStatusProp = contestStatusProp
      previousProps.contestTypeProp = contestTypeProp
    }
  }, [contestStatusProp, contestTypeProp])

  useEffect(() => {
    if (previousProps.startDateProp !== startDateProp || previousProps.endDateProp !== endDateProp) {
      if (startDateProp && endDateProp) {
        const start = 0
        const limit = offset

        dispatch(getUserContestList(start, limit, sort, order, search, startDateProp, endDateProp, { cStatus: contestStatusProp, cType: contestTypeProp }, false, "U",token))
        setSearch(search || '')
        setStartDate(startDateProp)
        setEndDate(endDateProp)
        setPageNo(1)
        setLoading(true)
      }
    }
    return () => {
      previousProps.startDateProp = startDateProp
      previousProps.endDateProp = endDateProp
    }
  }, [startDateProp, endDateProp])

  useEffect(() => {
    const callSearchService = () => {
      const start = 0
      const limit = offset
      dispatch(getUserContestList(start, limit, sort, order, props.search, startDate, endDate, { cStatus, cType }, false,"U",token))
      setSearch(searchProp)
      setPageNo(1)
      setLoading(true)
    }
    if (previousProps.searchProp !== searchProp && props.flag) {
      const debouncer = setTimeout(() => {
        callSearchService()
      }, 1000)
      return () => {
        clearTimeout(debouncer)
        previousProps.searchProp = searchProp
      }
    }
    return () => {
      previousProps.searchProp = searchProp
    }
  }, [searchProp])

  // function handleSelect (ranges) {
  //   setselectionRange({
  //     startDate: ranges.selection.startDate,
  //     endDate: ranges.selection.endDate,
  //     key: 'selection'
  //   })
  // }

  // function onClose () {
  //   props.handleDateRangePicker(false, startDate, endDate)
  // }

  // function onConfirmRange () {
  //   if (selectionRange.startDate) {
  //     setStartDate(moment(selectionRange.startDate).format('lll'))
  //   }
  //   if (selectionRange.endDate) {
  //     setEndDate(moment(selectionRange.endDate).format('lll'))
  //   }
  //   const start = 0
  //   const limit = offset
  //   dispatch(getUserContestList(start, limit, sort, order, search, selectionRange.startDate, selectionRange.endDate, { cStatus, cType }, false, token))
  //   setLoading(true)
  //   props.handleDateRangePicker(false, selectionRange.startDate, selectionRange.endDate)
  //   setLoading(true)
  //   setPageNo(1)
  // }

  // function onPageChange (pageState) {
  //   dispatch(getUserContestList(pageState.startIndex, pageState.pageSize, sort, order, search, startDate, endDate, { cStatus, cType }, false, token))
  //   setLoading(true)
  // }

  // function onSorting () {
  //   if (order === 'asc') {
  //     const start = 0
  //     const limit = offset
  //     dispatch(getUserContestList(start, limit, sort, 'desc', search, startDate, endDate, { cStatus, cType }, false, token))
  //     setOrder('desc')
  //     setPageNo(1)
  //     setLoading(true)
  //   } else {
  //     const start = 0
  //     const limit = offset
  //     dispatch(getUserContestList(start, limit, sort, 'asc', search, startDate, endDate, { cStatus, cType }, false, token))
  //     setOrder('asc')
  //     setPageNo(1)
  //     setLoading(true)
  //   }
  // }

  // function onReset () {
  //   setselectionRange({
  //     startDate: '',
  //     endDate: '',
  //     key: 'selection'
  //   })
  //   setStartDate('')
  //   setEndDate('')
  //   props.handleDateRangePicker(true, '', '')
  // }

  // function onExport () {
  //   const { total } = userContestList
  //   if (total < 11) {
  //     exporter.current.props = { ...exporter.current.props, data: processExcelExportData(list), fileName: 'UserContests.xlsx' }
  //     exporter.current.save()
  //   } else {
  //     const start = 0
  //     dispatch(getUserContestList(start, userContestList.total, sort, order, search, startDate, endDate, { cStatus, cType }, true, token))
  //   }
  // }

  // useImperativeHandle(excelRef, () => ({
  //   onExport
  // }))

  return (
    <Fragment>
        <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Sr no.</th>
              <th>Contest Name</th>
              <th>Contest Tickets</th>
              {/* <th>Contest Type</th> */}
              {/* <th> Contest Ticket</th> */}
              {/* <th>Bonus</th> */}
              {/* <th>Ticket Rate</th> */}
              <th>
                Date &amp; Time
                <Button color="link" className="sort-btn">
                  {/* <img src={sortIcon} className="m-0" alt="sorting" /> */}
                </Button>
              </th>
              {/* <th>Repeat</th> */}
              <th>Status</th>
              {/* <th>Creator Bonus</th>
              <th>Prize Distribution</th> */}
              {/* {permission === constants.READ_PERMISSION || permission === constants.WRITE_PERMISSION
                ? (
                <th>Action</th>
                  )
                : null} */}
            </tr>
          </thead>
          <tbody>
            {loading
              ? <SkeletonTable numberOfColumns={permission !== constants.NO_PERMISSION ? 9 : 10} />
              : (
                <Fragment>
                  {
                    list.map((data, i) => {
                      let dStartTime = moment(data.dStartTime).local().format('lll')
                      dStartTime = dStartTime === 'Invalid date' ? ' - ' : dStartTime
                      return (
                        <tr key={data._id}>
                          <td>{(((activePageNo - 1) * offset) + (i + 1))}</td>
                          <td>{data?.sName}</td>
                          {/* <td>{data.eType === 'RP' ? 'Ready to Play' : (data.iCreatorId ? 'Private Contest' : 'Time Based')}</td> */}
                          <td>{data?.nTickets}</td>
                          {/* <td>{`Rs. ${data.nBonus || 0} `}</td>
                          <td>{`Rs. ${data.nTicketPrice || 0} `}</td> */}
                          <td>{dStartTime}</td>
                          {/* <td>{data.eRepeatTime === 'D' ? 'Daily' : data.eRepeatTime === 'W' ? 'Weekly' : 'None'}</td> */}
                          <td>{data?.eStatus === 'P' ? 'Pending' : data.eStatus === 'U' ? 'Upcoming' : data.eStatus === 'L' ? 'Live' : data.eStatus === 'CMP' ? 'Completed' : 'Cancel'}</td>
                          {/* <td>{data.iCreatorId ? `Rs. ${data.nCreatorBonus || 0}` : 'NA'}</td>
                          <td>
                            {
                              data.eStatus === 'CMP'
                                ? (
                                  <span>{data.dPrizeDistribution ? 'Completed' : 'Pending'}</span>
                                  )
                                : '-'
                            }
                          </td> */}
                          {/* {permission === constants.WRITE_PERMISSION || permission === constants.READ_PERMISSION
                            eslint-disable-next-line multiline-ternary
                            ? (
                            <td>
                                <ul className="action-list mb-0 d-flex">
                                  <li>
                                    <NavLink to={`/contest/user-contest-view/${data._id}`} className="view">
                                      <img src={viewIcon} alt="View" />
                                      <span>View</span>
                                    </NavLink>
                                  </li>
                                  <li><Button color="link" className="edit"><img src={editIcon} alt="Edit" /><span>Edit</span></Button></li>
                              <li><Button color="link" className="delete"><img src={deleteIcon} alt="Delete" /> <span>Delete</span></Button></li>
                                </ul>
                              </td>
                              ) : null} */}
                        </tr>
                      )
                    })
                  }
                </Fragment>
                )}
          </tbody>
        </table>
      </div>
    </Fragment>
  )
})

UserContestContent.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object,
  search: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  openPicker: PropTypes.bool,
  contestStatusProp: PropTypes.bool,
  contestFilter: PropTypes.bool,
  handleDateRangePicker: PropTypes.string,
  flag: PropTypes.bool
}
UserContestContent.displayName = UserContestContent
export default connect(null, null, null, { forwardRef: true })(UserContestContent)
